import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, NgZone, OnDestroy, OnInit, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { NotifierService } from "@nahuelmorata/angular-notifier";
import { Subscription } from "rxjs";
import { NotificacionServiceReceptor } from "@shared/services";
import { GlobalAcciones } from "@shared/states";
import { environment } from "../environments/environment";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {
    private subs = new Subscription();

    private readonly notifierService = inject(NotifierService);
    private readonly zone = inject(NgZone);
    private readonly store = inject(Store);
    private readonly notificacionService = inject(NotificacionServiceReceptor);
    private readonly breakpointObserver = inject(BreakpointObserver);
    
    constructor() {
        this.notificacionService.cerrarNotificacion$.pipe(
            takeUntilDestroyed()
        ).subscribe(id => this.notifierService.hide(id));
    }

    ngOnInit() {
        document.body.setAttribute("appVersion", environment.version);

        this.subs.add(
            this.notificacionService.envioNotificacion$.subscribe(datosNotificacion => {
                if (datosNotificacion.estaAfueraDeAngular) {
                    this.zone.run(() => {
                        this.notifierService.notify(datosNotificacion.tipo, datosNotificacion.mensaje);
                    });

                    return;
                }

                this.notifierService.notify(datosNotificacion.tipo, datosNotificacion.mensaje);
            })
        );
        this.subs.add(
            this.breakpointObserver.observe([
                Breakpoints.Small,
                Breakpoints.XSmall
            ]).subscribe(result => {
                this.store.dispatch(new GlobalAcciones.EstablecerEsTelefono(result.breakpoints[Breakpoints.XSmall]));
                this.store.dispatch(new GlobalAcciones.EstablecerEsTablet(result.breakpoints[Breakpoints.Small]));
            })
        );
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    /*private hayNuevaVersion(versionActual: string, versionNueva: string) {
        if (versionActual === versionNueva) {
            return false;
        }

        let versiones = [versionActual, versionNueva];

        versiones = versiones.sort((a,b) => b.startsWith(a) ? 1 : (a > b ? 1 : (a < b ? -1 : 0)));

        return versiones.pop() === versionNueva;
    }*/
}
